'use strict';

/**
* Tests if a value is a string primitive.
*
* @param {*} value - value to test
* @returns {Boolean} boolean indicating if a value is a string primitive
*/
function isString( value ) {
	return typeof value === 'string';
} // end FUNCTION isString()


// EXPORTS //

module.exports = isString;



//////////////////
// WEBPACK FOOTER
// ./~/validate.io-string-primitive/lib/index.js
// module id = 146
// module chunks = 0